
import { defineComponent, toRefs, reactive, PropType } from "@vue/runtime-core";
import { Burst } from "@/interfaces/Burst";
import { isBurstSelected, maxBurstsSelected } from "@/helpers/store";
import { computed, ComputedRef } from "vue";

export default defineComponent({
  props: {
    burst: {
      required: true,
      type: Object as PropType<Burst>,
    },
    toggleBurst: {
      required: false,
      type: Function,
      default: null,
    },
  },
  setup(props) {
    const state = reactive({
      burst: props.burst,
      toggleBurst: props.toggleBurst,
      idModifier: Math.random(),
    });

    const topBurstTags: ComputedRef<string[]> = computed(() =>
      Object.entries(state.burst.SensorTags)
        .filter((entry) => {
          if (
            entry[0] != "Customer" &&
            entry[0] != "Units" &&
            entry[0] != "NodeName" &&
            entry[0] != "Rig" &&
            entry[0] != "NodeMac"
          )
            return entry;
        })
        .map((entry) => `${entry[0]}: ${entry[1]}`)
    );

    return {
      ...toRefs(state),
      isBurstSelected,
      maxBurstsSelected,
      topBurstTags,
    };
  },
});
